import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PouchService } from '../../services/pouch-service';
import { Router } from '@angular/router';
interface ImageModel {
  type: string;
  image: string;
}

@Component({
  selector: 'horizontal-scroll',
  templateUrl: './horizontal-scroll.html',
  styleUrls: ['horizontal-scroll.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HorizontalScrollComponent implements OnInit, OnChanges {
  @Input() linkLabel = 'link';
  @Input() pages: any[] = [];
  @Input() background: string;
  @Input() text: string;
  @Input() hideNav = false;
  @Input() navIcon: ImageModel;
  @Input() distance = 500;
  @Input() scrollSpeed = 5000;
  @Output() clickedEventEmiiter = new EventEmitter<any>();
  leftArrowHide = false;
  rightArrow = false;

  @ViewChild('hScroll', { static: false }) scrollWrapper: ElementRef;

  interval: any;

  constructor(public db: PouchService, private router: Router) {}

  ngOnInit(): void {
    setTimeout(() => {
      if (this.scrollWrapper.nativeElement.scrollWidth <= this.scrollWrapper.nativeElement.clientWidth) {
        this.leftArrowHide = true;
        this.rightArrow = true;
      }
    }, 100);
  }

  listenToItemsScroll(e): void {
    this.leftArrowHide = e.left_arrow;
    this.rightArrow = e.right_arrow;
  }

  scrollLeft(): void {
    const leftArrow = document.getElementById('list-items');
    const scrollLeft = leftArrow.scrollLeft;
    const distance = scrollLeft - this.distance;
    this.scroll(distance);
  }

  left(): void {
    const d = this;
    this.interval = setInterval(() => {
      d.scrollLeft();
    }, this.scrollSpeed);
  }

  scrollRight(): void {
    const listWrapper = document.getElementById('list-items');
    const scrollLeft = listWrapper.scrollLeft;
    const distance = scrollLeft + this.distance;
    this.scroll(distance);
  }

  right(): void {
    const d = this;
    this.interval = setInterval(() => {
      d.scrollRight();
    }, this.scrollSpeed);
  }

  scroll(distance): void {
    const listWrapper = document.getElementById('list-items');
    listWrapper.scrollTo({ behavior: 'smooth', left: distance });
  }

  clear(): void {
    clearInterval(this.interval);
  }

  onLinkClicked(item: any): void {
    this.clickedEventEmiiter.emit(item);
  }

  ngOnChanges(simp: SimpleChanges): void {
    Object.keys(simp).forEach((key) => (this[key] = simp[key].currentValue));
  }

  open(type, mode) {
    if (type == 'chat') {
      this.router.navigateByUrl('/ChatPage');
    } else {
      this.router.navigateByUrl(type, { state: { mode: mode } });
    }
  }
}
